module.exports = new __parcel__URL__("searchNoResults.7be90ed3.svg").toString();